import styled from '@emotion/styled'
import { BackdropModal } from '@helpers/styles'

const BackdropWithModalStyles = styled(BackdropModal)`
	.delete-products-modal-action-part {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-top: 12px;

		.delete-products-modal-cancel-button {
			margin-right: 10px;
		}
	}
`

export { BackdropWithModalStyles }
